import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VDataTable,{staticClass:"custom-elevation rounded-xl",attrs:{"loading":_vm.isLoading,"headers":_vm.headers,"items":_vm.creationRestrictions,"search":_vm.search},scopedSlots:_vm._u([{key:"item.status",fn:function(ref){
var item = ref.item;
return [_c(VChip,{attrs:{"color":_vm.status(item).color(),"small":"","outlined":"","pill":""}},[_vm._v(_vm._s(item.status))])]}},{key:"item.clientName",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.clientName)+" ")]}},{key:"item.ownerName",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.getAdminById(item.ownerId).name)+" ")]}},{key:"item.locationName",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.locationName)+" ")]}},{key:"item.dateFrom",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatDate(item.dateFrom))+" ")]}},{key:"item.dateUntil",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-flex align-center"},[_vm._v(" "+_vm._s(_vm.formatDate(item.dateUntil))+" ")])]}},{key:"item.message",fn:function(ref){
var item = ref.item;
return [_c(VTooltip,{attrs:{"bottom":"","max-width":"400px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('span',_vm._g(_vm._b({},'span',attrs,false),on),[_vm._v(" "+_vm._s(_vm._f("truncateText")(item.message,50))+" ")])]}}],null,true)},[_c('span',[_vm._v(_vm._s(item.message))])])]}},{key:"item.actions",fn:function(ref){
var item = ref.item;
return [_c(VMenu,{attrs:{"rounded":"","offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c(VBtn,_vm._g(_vm._b({attrs:{"depressed":"","icon":""}},'v-btn',attrs,false),on),[_c(VIcon,[_vm._v("mdi-dots-vertical")])],1)]}}],null,true)},[_c(VList,[_c(VListItem,{attrs:{"link":""},on:{"click":function($event){return _vm.handleExtendClick(item)}}},[_c(VListItemTitle,[_vm._v(_vm._s(_vm.$t('locationRestrictions.list.extendTooltip')))])],1),_c(VListItem,{attrs:{"link":""},on:{"click":function($event){return _vm.handleRemoveClick(item)}}},[_c(VListItemTitle,[_vm._v(_vm._s(_vm.$t('locationRestrictions.list.finishLabel')))])],1)],1)],1)]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }